<template>
    <div>
        <form @submit.prevent="submitFiles">
            <div class="dropbox">
                <b-form-file 
                    @change="onFileChange($event)" 
                    :placeholder="$t('Inserir anexos')"
                    :browse-text="$t('Adicionar Arquivos')"
                    multiple                    
                    ref="file-input"
                    class="mb-2"
                    :state="Boolean(files.length)"
                    :file-name-formatter="formatNames"
                    id="formFiles"
                    v-model="selectFiles"
                ></b-form-file>
            </div>
            <button class="btn btn-success d-none" type="submit" id="btnFormFiles">{{$t('Enviar Anexos')}}</button>
        </form>
        <button v-if="this.files.length > 0 " class="btn btn-light" @click="limparArquivos" >X Limpar</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            files: [], // Lista acumulativa de arquivos,
            selectFiles: ''
        };
    },
    methods: {
        formatNames() {
            return this.files.length === 1 
                ? this.files[0].name 
                : `${this.files.length} arquivos selecionados`;
        },
        onFileChange(event) {
            const newFiles = Array.from(event.target.files);

            // Adicionar novos arquivos, evitando duplicados
            newFiles.forEach(file => {
                
                const isMp4 = file.type === 'video/mp4' || file.name.toLowerCase().endsWith('.mp4') || file.type === 'mkv' || file.name.toLowerCase().endsWith('.mkv');
                console.log(isMp4)
                if (isMp4) {
                    this.files.length = 0
                    document.getElementById('formFiles').value = ''
                    this.$store.commit('os/setFilesUpload', [])
                    this.selectFiles = ''
                    alert(`Tipo de arquivo não permitido.`);
                    return false
                }
            
                if (!this.files.some(existingFile => existingFile.name === file.name && existingFile.size === file.size)) {
                    this.files.push(file);
                }
            });

            // Atualizar no Vuex
            this.$store.commit('os/setFilesUpload', this.files);
        },
        limparArquivos(){
            this.files.length = 0
            this.$store.commit('os/setFilesUpload', [])
            this.selectFiles = ''
        },
        submitFiles() {
            const formData = new FormData();

            this.files.forEach(file => {
                formData.append('files[]', file);
            });

            this.$store.dispatch('os/uploadFiles', {
                data: formData,
                nrSeqOs: this.$route.params.id,
            }).then(response => {
                // Exibir mensagem de sucesso
                // this.$swal.fire({
                //     title: 'Sucesso!',
                //     text: 'Anexos cadastrados com sucesso!',
                //     icon: 'success',
                // });
            }).catch(error => {
                // console.error(error);
                // this.$swal.fire({
                //     title: 'Oops!', 
                //     text: 'Falha ao cadastrar anexos, tente novamente!',
                //     icon: 'error',
                // });
            });
        },
    },
};
</script>

<style>
/* .custom-file-input:lang(en)~.custom-file-label::after {
    content: 'Adicionar Arquivos';
} */
</style>
